import { createContext, type JSX, useContext } from 'solid-js'
import { MainModule } from '../../../features/main-module'
import { type GetCurrentUserInteractor } from '../../../features/auth/domain/interactors/get-current-user.interactor'
import { type UpdateCurrentUserInteractor } from '../../../features/auth/domain/interactors/update-current-user.interactor'

interface UserContextType {
  getCurrentUser: GetCurrentUserInteractor
  updateCurrentUser: UpdateCurrentUserInteractor
}

const CorisUserContext = createContext()

export const CorisUserProvider = (props: { children: JSX.Element }): JSX.Element => {
  const userComponent = MainModule.getAuthComponent()

  const defaultContextValue = {
    getCurrentUser: userComponent.provideGetCurrentUser(),
    updateCurrentUser: userComponent.provideUpdateCurrentUser()
  }

  return <CorisUserContext.Provider value={defaultContextValue}>{props.children}</CorisUserContext.Provider>
}

export const useCorisUser = (): UserContextType => {
  const context = useContext(CorisUserContext)
  if (!context) {
    throw new Error('useCorisUser must be used inside a CorisUserProvider')
  }
  return context as UserContextType
}
